import emailjs from '@emailjs/browser';

const SERVICE_ID = 'service_80wbd7m';
const TEMPLATE_ID = 'template_g1uxbn5';
const PUBLIC_KEY = 'M27CRKpw1YCUYBWK8';
const GOOGLE_SCRIPT_URL = process.env.REACT_APP_GOOGLE_SCRIPT_URL || process.env.REACT_APP_MICROSOFT_FLOW_URL || process.env.REACT_APP_MICROSOFT_WEBHOOK_URL || '';
const EMAILJS_ENABLED = Boolean(process.env.REACT_APP_EMAILJS_SERVICE_ID && process.env.REACT_APP_EMAILJS_TEMPLATE_ID && process.env.REACT_APP_EMAILJS_PUBLIC_KEY);

export const sendContactEmail = (form) => {
  if (!EMAILJS_ENABLED) {
    return Promise.resolve({ status: 'skipped' });
  }

  return emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form, PUBLIC_KEY);
};

export const buildContactPayload = (form, source = 'website') => {
  const isFormElement = typeof HTMLFormElement !== 'undefined' && form instanceof HTMLFormElement;
  const formData = isFormElement ? new FormData(form) : form;

  const getValue = (name) => {
    if (formData instanceof FormData) {
      return formData.get(name) ?? '';
    }

    return formData?.[name] ?? '';
  };

  const subscribeValue = getValue('subscribe');
  const subscribe = subscribeValue === true || subscribeValue === 'on' || subscribeValue === 'true' || subscribeValue === 1 || subscribeValue === '1';

  return {
    firstName: getValue('user_firstname') || '',
    lastName: getValue('user_lastname') || '',
    email: getValue('user_email') || '',
    contactNumber: getValue('contact_number') || '',
    message: getValue('message') || '',
    subscribe,
    source,
    submittedAt: new Date().toISOString(),
  };
};

export const sendToGoogleSheets = async (payload) => {
  if (!GOOGLE_SCRIPT_URL) {
    return null;
  }

  const response = await fetch(GOOGLE_SCRIPT_URL, {
    method: 'POST',
    mode: 'no-cors',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (response.type === 'opaque' || response.type === 'opaqueredirect' || response.status === 0) {
    return response;
  }

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || 'Google Sheets submission failed');
  }

  return response;
};

export const submitContactForm = async (form, source = 'website') => {
  const payload = buildContactPayload(form, source);

  if (GOOGLE_SCRIPT_URL) {
    await sendToGoogleSheets(payload);
    return { payload, results: [{ status: 'fulfilled' }] };
  }

  const emailResult = await sendContactEmail(form);
  return { payload, results: [{ status: 'fulfilled', value: emailResult }] };
};

export const sendConfirmationEmail = (templateParams) => {
  // Optional: send a confirmation email back to the customer.
  // Create a separate template in EmailJS if you want a customer reply email.
  return emailjs.send(SERVICE_ID, 'template_g1uxbn5', templateParams, PUBLIC_KEY);
};
